<template>
  <div class="szw-h-10 szw-w-full szw-bg-section-static szw-flex szw-flex-row szw-gap-y-2 szw-gap-6 szw-overflow-hidden">
    <div
      class="szw-flex szw-flex-col szw-flex-1 szw-text-xxs szw-capitalize szw-items-center szw-justify-center"
      v-for="stage in props.stages"
      :key="stage.id"
      :style="{ minWidth: `${cardWidth}px`, transform: translateX, transition: 'transform .3s' }"
    >
      <span class="szw-font-normal szw-text-[14px]">{{ stage.name }}</span>
    </div>
  </div>
</template>

<script setup>
/** @type {{stages: Array<{ id: string, name: string, startTime: string, endTime: string, duration: string }>}} */
const props = defineProps({
  stages: {
    type: Array,
    default: () => []
  },
  translateX: {
    type: String,
    default: 'translateX(0)'
  },
  cardWidth: {
    type: Number,
    default: 200
  }
})
</script>
